__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "load_tracking";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@enterprise-ui/canvas-ui-css-autocomplete", "7.15.3", function() { return function() { return __webpack_require__(15834); }; }, 1);
			register("@enterprise-ui/canvas-ui-css-autocomplete", "7.22.2", function() { return function() { return __webpack_require__(3769); }; }, 1);
			register("@enterprise-ui/canvas-ui-css-datepicker", "7.18.2", function() { return function() { return __webpack_require__(41872); }; }, 1);
			register("@enterprise-ui/canvas-ui-css", "7.18.2", function() { return function() { return __webpack_require__(88933); }; }, 1);
			register("@enterprise-ui/canvas-ui-css", "7.22.2", function() { return function() { return __webpack_require__(61820); }; }, 1);
			register("@enterprise-ui/canvas-ui-react-autocomplete", "7.22.2", function() { return function() { return __webpack_require__(40425); }; }, 1);
			register("@enterprise-ui/canvas-ui-react-datepicker", "7.22.2", function() { return function() { return __webpack_require__(54802); }; }, 1);
			register("@enterprise-ui/canvas-ui-react", "7.22.2", function() { return function() { return __webpack_require__(9280); }; }, 1);
			register("@enterprise-ui/component-font", "1.2.0", function() { return function() { return __webpack_require__(2419); }; }, 1);
			register("@enterprise-ui/icons", "1.17.5", function() { return function() { return __webpack_require__(16177); }; }, 1);
			register("@praxis/component-auth", "26.1.3", function() { return function() { return __webpack_require__(39160); }; }, 1);
			register("keycode-js", "3.1.0", function() { return function() { return __webpack_require__(9234); }; }, 1);
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(28108); }; }, 1);
			register("react-hook-form", "7.72.0", function() { return function() { return __webpack_require__(92376); }; }, 1);
			register("react-router-dom", "7.18.0", function() { return function() { return __webpack_require__(28092); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(66685); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};